import { useEffect } from "react";
import { useLocation } from "react-router-dom"


export const GetCurrentRoute: React.FunctionComponent<{
    setRoute: (route: string) => void
}> = ({
    setRoute
}) => {
    const location = useLocation();

    useEffect(() => {
        setRoute(location.pathname);
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    return null;
}